export type CourseProgramPoint = string;

export type CourseProgramItem = {
  id: string;
  title: string;
  subtitle?: string;
  week?: string;
  lead?: string;
  points?: CourseProgramPoint[];
};

export type CourseProgramSection = {
  id: string;
  label?: string;
  title: string;
  items: CourseProgramItem[];
};

export const courseProgramData: CourseProgramSection[] = [
  {
    id: "theory",
    label: "Теория",
    title: "Обучающая программа. 6 недель",
    items: [
      {
        id: "t1",
        title: "Основы ИТ подбора",
        subtitle: "2 урока",
        week: "1-ая неделя",
        lead: "Откроешь для себя мир ИТ подбора",
        points: [
          "Узнаешь об ИТ подборе, его задачах и основных этапах.",
          "Онлайн разбор вопросов с преподавателем.",
        ],
      },
      {
        id: "t2",
        title: "Технический минимум",
        subtitle: "2 урока",
        week: "2-ая неделя",
        lead:
          "Узнаешь основные профессии в ИТ, познакомишься с современными технологиями и будешь как рыба в мире разработки.",
        points: [
          "Онлайн вебинар с действующим Разработчиком.",
          "Онлайн вебинар по техническому минимуму с преподавателем.",
        ],
      },
      {
        id: "t3",
        title: "Сорсинг",
        subtitle: "2 урока",
        week: "3-ая неделя",
        lead:
          "Научишься искать ИТ-специалистов лучше, чем Шерлок Холмс преступников.",
        points: [
          "Онлайн разбор вопросов с преподавателем.",
          "Онлайн соревнование по сорсингу.",
          "Онлайн вебинар с действующим ИТ специалистом.",
        ],
      },
      {
        id: "t4",
        title: "Все о текстах в ИТ подборе",
        subtitle: "2 урока",
        week: "4-ая неделя",
        lead:
          "Узнаешь, какие есть тексты в ИТ подборе и научишься писать вакансии, письма и рекомендации в своем уникальном стиле.",
        points: [
          "Онлайн разбор вопросов с преподавателем.",
          "Онлайн вебинар с действующим ИТ разработчиком.",
        ],
      },
      {
        id: "t5",
        title: "Коммуникация в ИТ подборе",
        subtitle: "2 урока",
        week: "5-ая неделя",
        lead:
          "Научишься правильно выстраивать коммуникацию с каждым участником процесса подбора.",
        points: [
          "Научишься правильно выстраивать коммуникацию с каждым участником процесса подбора.",
          "Онлайн разбор вопросов с преподавателем.",
        ],
      },
      {
        id: "t6",
        title: "Дипломная работа",
        subtitle: "Проект",
        week: "6-ая неделя",
        points: [
          "Обсуждение заданий с преподавателем.",
          "Выдача сертификатов.",
        ],
      },
    ],
  },
  {
    id: "practice",
    label: "Практика",
    title: "Оттачиваем навыки на практике. 8 недель",
    items: [
      {
        id: "p1",
        title: "Вводим в курс дела",
        subtitle: "1 неделя",
        week: "1-ая неделя",
        lead: "Знакомство со структурой работы внутри блока, получение вакансий.",
        points: [
          "Онлайн вебинар по практике.",
          "Онлайн созвон по обсуждению вопросов.",
          "Проверка и корректировка заданий от куратора.",
        ],
      },
      {
        id: "p2",
        title: "Практика",
        subtitle: "2–4 недели",
        week: "2 - 4 ая неделя",
        lead:
          "Настоящая работа в роли специалиста ИТ подбора внутри команды студентов под наблюдением куратора.",
        points: [
          "Онлайн разбор вопросов 2 раза в неделю.",
          "Обратная связь по работе в чате 24/7.",
          "Еженедельный вебинар: работа над Linkedin, командный коучинг «постановка целей», практическая игра «закрой оффер».",
        ],
      },
      {
        id: "p3",
        title: "Завершение практического блока, сопровождение поиска работы",
        subtitle: "4–8 недель",
        week: "4 - 8 ая неделя",
        points: [
          "Проведение онлайн выпускного.",
          "Вебинар по созданию резюме.",
          "Корректировка резюме куратором.",
          "Вебинар по поиску работы.",
          "Организация собеседований в компании-партнеры.",
          "Ежедневная отправка вакансий в чат группы.",
        ],
      },
    ],
  },
];
